import { render, staticRenderFns } from "./RingTreeForm.vue?vue&type=template&id=7b96c7c2"
import script from "./RingTreeForm.vue?vue&type=script&lang=js"
export * from "./RingTreeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports